export const iconFontAwesomeArrowsLeftLong = (
	<i className="fa-solid fa-left-long"></i>
);
